export default class Booking{
    constructor(){
        this.cookie_duration    = "15min";
        this.activeTab          = "packet_choice";
        this.packet             = 0;
        this.object_id          = 0;
        this.address            = null;
        this.improvement        = null;
        this.improvementObjects = null;
        this.article_count      = 0;
    }

    setActiveTab(val) {
        this.activeTab = val;
    }
    getActiveTab() {
        return this.activeTab;
    }

    setObjectId(val) {
        this.object_id = val;
    }
    getObjectId() {
        return this.object_id;
    }

    setArticleCount(val) {
        this.article_count = val;
    }
    getArticleCount() {
        return this.article_count;
    }

    setPacket(val) {
        this.packet = val;
    }
    getPacket() {
        return this.packet;
    }

    setAddress(val) {
        this.address = val;
    }
    getAddress() {
        return this.address;
    }

    setImprovement(val) {
        this.improvement = JSON.stringify(val);
    }
    getImprovement() {
        return this.improvement != null ? JSON.parse(this.improvement) : {};
    }

    setImprovementObjects(val) {
        this.improvementObjects = JSON.stringify(val);
    }
    getImprovementObjects() {
        return this.improvementObjects != null ? JSON.parse(this.improvementObjects) : null;
    }

    static getObjectFromJSON(jsonObject) {
        let booking = new Booking();

        if(jsonObject == null){
            return booking;
        }

        booking.object_id          = jsonObject.object_id          
        booking.activeTab          = jsonObject.activeTab          
        booking.packet             = jsonObject.packet             
        booking.address            = jsonObject.address            
        booking.improvement        = jsonObject.improvement        
        booking.article_count      = jsonObject.article_count 
        booking.improvementObjects = jsonObject.improvementObjects 

        return booking;
    }
}